import { Box } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import TldrCollpasibleSection from "../../../common/TldrCollpasibleSection";
import TldrGradientCollapsibleSection from "../../../common/tldrGradients/TldrGradientCollapsibleSection";
import { StyledAdvEditorToolbarFormatGroup } from "../../../styled/details/stylesDetails";
import TLDRBold from "./TLDRBold";
import TLDRFontDropDown from "./TLDRFontDropDown";
import TLDRFontSize from "./TLDRFontSize";
import TLDRFontWeightDropDown from "./TLDRFontWeightDropDown";
import TLDRItalic from "./TLDRItalic";
import TLDRLineHeight from "./TLDRLineHeight";
import TLDRLineSpace from "./TLDRLineSpace";
import TLDRStrikethrough from "./TLDRStrikethrough";
import TLDRTextAlign from "./TLDRTextAlign";
import TLDRTextColor from "./TLDRTextColor";
import TLDRTextHighlightColor from "./TLDRTextHighlightColor";
import TLDRTextScript from "./TLDRTextScript";
import TLDRUnderline from "./TLDRUnderline";

class AdvancedTextEditorToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = { collapse: false };
  }

  handleToggleChange = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    const { editor, canvasRef, brandKit, t } = this.props;
    const { activeElement } = editor;

    return (
      <>
        <TldrCollpasibleSection
          title="Typography"
          collapse={this.state.collapse}
          onToggleCollapse={this.handleToggleChange}
        >
          <StyledAdvEditorToolbarFormatGroup mb="1rem">
            <div className="title">{t("fonts.font_n_size")}</div>
            <Box className="actions" ml={0}>
              <TLDRFontDropDown canvasRef={canvasRef} />
              <TLDRFontWeightDropDown canvasRef={canvasRef} />
            </Box>
          </StyledAdvEditorToolbarFormatGroup>

          <StyledAdvEditorToolbarFormatGroup mb="1rem">
            <Box className="actions" ml={0}>
              <TLDRFontSize canvasRef={canvasRef} />

              <TLDRBold canvasRef={canvasRef} />
              <TLDRItalic canvasRef={canvasRef} />
              <TLDRUnderline canvasRef={canvasRef} />
              <TLDRStrikethrough canvasRef={canvasRef} />
            </Box>
          </StyledAdvEditorToolbarFormatGroup>

          <StyledAdvEditorToolbarFormatGroup mb="1rem">
            <div className="title">{t("fonts.color")}</div>
            <Box className="actions" justifyContent={"space-between"} ml={0}>
              <TLDRTextColor
                canvasRef={canvasRef}
                top={40}
                right={brandKit.brandkitPayload.length > 0 ? -89 : -71}
                zIndex={this.props.isMobileView ? 1 : 3}
                showHexCode={true}
              />
              <TLDRTextHighlightColor
                canvasRef={canvasRef}
                top={40}
                right={0}
                zIndex={this.props.isMobileView ? 1 : 3}
                showHexCode={true}
              />
            </Box>
          </StyledAdvEditorToolbarFormatGroup>

          <Box display="flex" justifyContent={"space-between"}>
            <StyledAdvEditorToolbarFormatGroup mb="1rem">
              <div className="title">{t("fonts.text_align")}</div>
              <div className="actions">
                <TLDRTextAlign canvasRef={canvasRef} />
              </div>
            </StyledAdvEditorToolbarFormatGroup>

            <StyledAdvEditorToolbarFormatGroup mb="1rem">
              <div className="title">{t("extras", { ns: "common" })}</div>
              <div className="actions">
                <TLDRTextScript canvasRef={canvasRef} />
              </div>
            </StyledAdvEditorToolbarFormatGroup>
          </Box>
          <Box className="actions" mb={2}>
            <TLDRLineHeight canvasRef={canvasRef} />
          </Box>
          <Box className="actions" mb={2}>
            <TLDRLineSpace canvasRef={canvasRef} />
          </Box>
        </TldrCollpasibleSection>
        <TldrGradientCollapsibleSection
          canvasRef={canvasRef}
          mime={activeElement.mime}
        />
      </>
    );
  }

  componentDidMount() {
    // Do nothing
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}
}

AdvancedTextEditorToolbar.propTypes = {
  editor: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  brandKit: state.brandKit,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["studio", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(AdvancedTextEditorToolbar)
);
